import { AdvertisementsOffIcon } from './AdvertisementsOffIcon';

/**
 * author: Michael Irigoyen
 * id 28583E81-1315-4397-8FC5-46325CF1FB94
 * name advertisements-off
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/advertisements-off.svg
 * tags
 */
export const AdsOffIcon = AdvertisementsOffIcon;
export default AdsOffIcon